import { useEffect, useState } from "react";
import client, { getErrorMessage } from "@/api/client";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

// Asset Register edit screen — per-asset Quantity for each shared Piling rig schedule line.
export default function ServiceQuantities({ assetId, onChange }) {
  const [lines, setLines] = useState(null);

  useEffect(() => {
    client.get(`/service-tracker/assets/${encodeURIComponent(assetId)}/quantities`)
      .then((r) => setLines(r.data.lines.map((l) => ({ ...l, quantity: l.quantity ?? "" }))))
      .catch((e) => toast.error(getErrorMessage(e)));
  }, [assetId]);

  if (!lines) return null;

  const update = (id, v) => {
    const next = lines.map((l) => (l.line_id === id ? { ...l, quantity: v } : l));
    setLines(next);
    onChange(next.map((l) => ({ line_id: l.line_id, quantity: l.quantity === "" ? null : Number(l.quantity) })));
  };

  return (
    <div className="col-span-2 space-y-2" data-testid="asset-service-quantities">
      <p className="text-sm font-semibold text-slate-800">Service Tracker — Quantities</p>
      <p className="text-xs text-slate-500">Lines come from the shared Piling rig Service Schedule. Only Quantity is editable here.</p>
      <div className="rounded-md border border-slate-200 overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Service Type</TableHead>
              <TableHead>Interval (hrs)</TableHead>
              <TableHead>Grade</TableHead>
              <TableHead className="w-32">Quantity</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {lines.length === 0 ? (
              <TableRow><TableCell colSpan={4} className="text-center text-slate-400 py-4" data-testid="asset-service-quantities-empty">No schedule lines defined yet.</TableCell></TableRow>
            ) : lines.map((l) => (
              <TableRow key={l.line_id} data-testid={`asset-service-qty-row-${l.line_id}`}>
                <TableCell>{l.service_type}</TableCell>
                <TableCell>{l.interval_hours}</TableCell>
                <TableCell>{l.grade}</TableCell>
                <TableCell>
                  <Input type="number" min="0" step="any" className="h-8" data-testid={`asset-service-qty-input-${l.line_id}`} value={l.quantity} onChange={(e) => update(l.line_id, e.target.value)} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
